import { createContext, useContext, useState, ReactNode, useMemo } from "react";
import { Language, t as translate } from "@/i18n/translations";

interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}

const defaultValue: LanguageContextType = {
  lang: "ro",
  setLang: () => {},
  t: (key: string) => translate(key, "ro"),
};

const LanguageContext = createContext<LanguageContextType>(defaultValue);

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Language>("ro");

  const value = useMemo<LanguageContextType>(
    () => ({ lang, setLang, t: (key: string) => translate(key, lang) }),
    [lang]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
